export const SET_USER_REPORTS_LOADED = "SET_USER_REPORTS_LOADED";

export const setUserReportsLoaded = (userReportsLoaded: boolean) => {
  return {
    userReportsLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USER_REPORTS_LOADED
  };
};
